import gql from 'graphql-tag'
import Link from 'next/link'
import styled, { css } from 'styled-components'
import { TeamRecruitMessage_EmbedDataFragment } from 'generated/graphql'
import useShowComponentByAppVersion from '@app.feature/activityDetail/hooks/useShowComponentByAppVersion'
import { VERIFIED_APP_VERSIONS } from 'constants/verifyAppVersion/verifyAppVersionList'

gql`
  fragment TeamRecruitMessage_embedData on EmbedData {
    embedType
    title
    subtitle
    content
    url
    urlText
  }
`

interface TeamRecruitMessageProps {
  embedData: TeamRecruitMessage_EmbedDataFragment
  viewerIsSender: boolean
}

const TeamRecruitMessage = ({
  embedData,
  viewerIsSender,
}: TeamRecruitMessageProps) => {
  const isTeamRecruitVisibleVersion = useShowComponentByAppVersion(
    VERIFIED_APP_VERSIONS.TEAM_RECRUIT,
  )

  return (
    <StyledWrapper className={viewerIsSender ? 'sender' : ''}>
      {isTeamRecruitVisibleVersion ? (
        <>
          <div className="team-recruit-embed-header">
            <p className="team-recruit-region-tag">{embedData.subtitle}</p>
            <strong>{embedData.title}</strong>
          </div>
          <span>{embedData.content}</span>
          <Link href={embedData.url || ''}>
            <a>{embedData.urlText}</a>
          </Link>
        </>
      ) : (
        <span className="app-update-message">
          앱 업데이트 후 채팅을 확인해보세요
        </span>
      )}
    </StyledWrapper>
  )
}

export default TeamRecruitMessage

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    max-width: 225px;
    border-radius: 8px;
    background-color: #f3f4f8;
    padding: 10px 12px;

    &.sender {
      background-color: #eaf8ff;
    }

    .team-recruit-embed-header {
      display: flex;
      align-items: center;
      gap: 6px;
      padding-bottom: 8px;
      border-bottom: 1px solid ${theme.line.line_2};

      > strong {
        font-size: 13px;
        line-height: 19px;
        letter-spacing: -0.52px;
        color: ${theme.color.text_1};
        display: block;
      }

      > .team-recruit-region-tag {
        display: inline-flex;
        align-items: center;
        height: 24px;
        background-color: ${theme.background.bg_8};
        border-radius: 5px;
        padding: 4px 7px;
        font-size: ${theme.isMobile ? '11px' : '12px'};
        font-weight: bold;
        color: ${theme.color.primary_2};
        letter-spacing: -0.48px;
      }
    }

    & > span {
      width: 100%;
      font-size: 15px;
      font-weight: normal;
      word-break: break-all;
      color: ${theme.color.text_1};
      display: block;
      margin: 7px 0 12px;
    }

    & > .app-update-message {
      margin: 0;
      font-size: 14px;
    }

    & > a {
      width: 100%;
      height: 32px;
      font-size: 12px;
      font-weight: bold;
      line-height: 32px;
      text-align: center;
      color: #ffffff;
      border-radius: 8px;
      background-color: ${theme.color.primary_2};
      display: block;
    }
  `}
`
